import { i18n } from './i18n'

/**
 * Hook providing translation functions from the i18n singleton.
 *
 * Returns bound `t` and `plural` methods. No React state — re-renders
 * are triggered by locale changes only if i18n is re-initialised and
 * a parent component re-renders (sufficient for single-locale-per-session use).
 *
 * @returns {{ t: i18n['t'], plural: i18n['plural'] }}
 *
 * @example
 * const { t, plural } = useI18n()
 * t('common.close')                                    // → 'Zamknij'
 * t('catalog.results_count', { count: 5 })             // → 'Znaleziono 5'
 * plural('catalog.results_count', 5, { count: 5 })     // → 'Znaleziono 5 lokali'
 */
export function useI18n() {
  return {
    t: i18n.t.bind(i18n),
    plural: i18n.plural.bind(i18n),
  }
}
